import { render, staticRenderFns } from "./jinfengPacsdetal.vue?vue&type=template&id=2e53fb1e"
import script from "./jinfengPacsdetal.vue?vue&type=script&lang=js"
export * from "./jinfengPacsdetal.vue?vue&type=script&lang=js"
import style0 from "./jinfengPacsdetal.vue?vue&type=style&index=0&id=2e53fb1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports